import { useToast } from '@/hooks/use-toast';
import { Toast } from '@/components/ui/toast';

// Create local implementations of the toast subcomponents
const ToastClose = ({ children, ...props }: React.ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button className="toast-close" aria-label="Close" {...props}>
    {children || (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
      </svg>
    )}
  </button>
);

const ToastDescription = ({ children, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className="toast-description" {...props}>{children}</div>
);

const ToastTitle = ({ children, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className="toast-title" {...props}>{children}</div>
);

const ToastProvider = ({ children }: { children: React.ReactNode }) => <>{children}</>;

const ToastViewport = ({ children, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className="toast-viewport" {...props}>{children}</div>
);

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
// @ts-ignore - TODO: Fix this TypeScript error
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
